import { render, staticRenderFns } from "./KpiFolderMainPopup.vue?vue&type=template&id=21d27efa&scoped=true&"
import script from "./KpiFolderMainPopup.vue?vue&type=script&lang=ts&"
export * from "./KpiFolderMainPopup.vue?vue&type=script&lang=ts&"
import style0 from "./KpiFolderMainPopup.vue?vue&type=style&index=0&id=21d27efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d27efa",
  null
  
)

export default component.exports